import { useTranslation } from 'react-i18next';
import { useColorScheme } from '@platform/theme';
import { ColorSchemeCard } from './ColorSchemeCard';

/**
 * Вибір колірної схеми (профіль, «Вигляд»): 25 світлих і 25 темних схем v4 картками з мініатюрою; вибір одразу застосовується,
 * зберігається в профілі на сервері (colorScheme) і в браузері — useColorScheme (@platform/theme).
 */
export function ColorSchemePicker() {
  const { t } = useTranslation();
  const { scheme, schemes, setScheme } = useColorScheme();
  const groups = [
    { mode: 'light' as const, title: t('ui.lightSchemes', { count: schemes.filter((s) => s.mode === 'light').length }), modeLabel: t('ui.light') },
    { mode: 'dark' as const, title: t('ui.darkSchemes', { count: schemes.filter((s) => s.mode === 'dark').length }), modeLabel: t('ui.dark') },
  ];
  return (
    <section className="scheme-picker" aria-label={t('ui.colorScheme')}>
      <div className="scheme-picker__head">
        <span className="t-strong">{t('ui.colorScheme')}</span>
        <span className="muted">{t('ui.colorSchemeHint')}</span>
      </div>
      {groups.map((g) => (
        <div key={g.mode} className="scheme-picker__group">
          <div className="t-eyebrow">{g.title}</div>
          <div className="scheme-picker__grid">
            {schemes.filter((s) => s.mode === g.mode).map((s) => (
              <ColorSchemeCard key={s.id} scheme={s} active={s.id === scheme.id} modeLabel={g.modeLabel} onSelect={setScheme} />
            ))}
          </div>
        </div>
      ))}
    </section>
  );
}
